module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/calendar-c34e7ace32cd0aa436af1247fe0def23.png";